import React from 'react';
import { Text4 } from '../../../styles';
import moment from 'moment';
import { Badge, Button, Icon, Popover } from 'antd';
import { MERCHANT_REPORT_STATUS_TYPES, MONTH_MASTER } from '../../../constants';
import { PermissionHoc } from '../../HOC';

const PermissableButton = PermissionHoc(Button,"DOWNLOAD_REPORTS",{ is_component: true, fallbackComponent: null })


export const getReportsTableColumns = (props) => [{
    title: "Name",
    key: "name",
    render: (record) => <Text4>{record.name}</Text4>
}, {
    title: "Report Type",
    key: "report_type",
    render: (record) => <Text4>{record.report_type_label}</Text4>
}, {
    title: "Duration",
    key: "duration",
    render: (record) => <Text4>{moment(record.duration_start_date).format("LL")} to {moment(record.duration_end_date).format("LL")}</Text4>
}, {
    title: "Status",
    key: "status",
    render: (record) => <Badge color={MERCHANT_REPORT_STATUS_TYPES[record.status].color} text={MERCHANT_REPORT_STATUS_TYPES[record.status].label} />
}, {
    title: "Actions",
    key: "actions",
    render: (record) =>
        <div className="w-100 d-flex" >
            <Button type="link" style={{paddingLeft:'0px'}} onClick={() => props.toggleDetailsDrawer({ ...record })}><Icon type="eye" /> View Details</Button>
        {
            record.status == "generated"?
                <PermissableButton type="link" loading={props.loading} onClick={() => props.downloadReport({ ...record })}><Icon type="download" /> Download</PermissableButton>
                :
                <Popover
                    title={false}
                    content={
                        record.status == "no_data" ?
                            "No data found for this report." : 
                            <>
                                <span>Report generation is in progress.</span><br/>
                                <span>Please check back in a few minutes.</span>
                            </>
                    }
                    placement="left"
                >
                    <Button type="link" disabled><Icon type="download" /> Download</Button>
                </Popover>
        }
        </div>
}];

export const reportsTableFilterNodes = (current_user={}) => {
    const current_year = moment().year();
    const years = Array((current_year - 2020) + 1).fill('').map((v, idx) => 2020 + idx).reverse();
    let filters  = [{
        label: "Name",
        field: "name",
        placeholder: "Enter Name",
        inputType: "text",
        defaultValue: ""
    }, {
        label: "Report Type",
        field: "report_type",
        inputType: "select",
        defaultValue: undefined,
        width: 200,
        options: [
            {
                key: 1,
                value: "transfers",
                label: "Transfers"
            },
            {
                key: 2,
                value: "account_statement",
                label: "Account Statement"
            },
            {
                key: 3,
                value: "utilities",
                label: "Utilities"
            },
            {
                key: 4,
                value: "insta_collect_collection",
                label: "InstaCollect Collections"
            },
            {
                key: 5,
                value: "insta_collect_settlements",
                label: "InstaCollect Settlements"
            },
            {
                key: 6,
                value: "insta_collect_refunds",
                label: "InstaCollect Refunds"
            },
            {
                key: 7,
                value: "webhook",
                label: "Webhook"
            },
            {
                key: 8,
                value: "insta_collect_account_statement",
                label: "InstaCollect Account Statement"
            },
            {
                key: 9,
                value: "beneficiaries",
                label: "Beneficiaries"
            },
            {
                key: 10,
                value: "submerchant_transfers",
                label: "Merchant Transfers"
            },
            {
                key: 11,
                value: "submerchant_insta_collect_collection",
                label: "Merchant InstaCollect Collection"
            },
            {
                key: 12,
                value: "insta_collect_orders",
                label: "InstaCollect Orders"
            },
            {
                key: 13,
                value: "insta_collect_settlement_mapping",
                label: "InstaCollect Settlement Mapping"
            },
            {
                key: 14,
                value: "insta_collect_consolidated_settlement_mapping",
                label: "InstaCollect Consolidated Settlement Mapping"
            },
        ]
    }, {
        label: "Year",
        field: "year",
        inputType: "select",
        defaultValue: current_year,
        options: years.map((year, index) => {
            return Object.create({
                key: index + 1,
                value: year,
                label: year    
            })
        })
    }, {
        label: "Month",
        field: "month",
        inputType: "select",
        defaultValue: undefined,
        options: MONTH_MASTER.map((month, index) => {
            return Object.create({
                key: index + 1,
                value: month.value,
                label: month.label
            })
        })
    },
]
if (current_user?.is_reseller && current_user?.esda){
    filters.unshift({
        label: "Merchant",
        field: "submerchant_id",
        placeholder: "Merchant ID",
        width: 200,
        inputType: "select",
        showSearch: true,
        defaultValue: undefined,
        options: current_user.submerchants ? current_user.submerchants.map((sub_merchant, index) => {
            let object = {};
            object.key = index;
            object.value = sub_merchant.id;
            object.label = sub_merchant.name+" ("+sub_merchant.email+")"
            return object;
        }): []

    })

}
return filters;
};